<template>
  <loader v-if="loading" />
  <back />
  <div v-if="pageLoaded">
    <div class="mt-2">
      <div class="bg-white px-6 pt-3 rounded-lg shadow">
        <div class="flex items-center justify-between mb-7">
          <div>
            <div class="md:mt-3 items-center flex gap-x-3">
              <p class="text-lg text-brand-black font-bold capitalize">{{ jobDetails?.role_title }}</p>
              <span :class="['px-4 py-1 text-[12px] rounded-md text-white', jobDetails?.status == 'open' ? 'bg-[#00AD73] ' : 'bg-brand-danger ']">{{
                jobDetails?.status
              }}</span>
            </div>

            <p class="text-sm font-normal text-[#8F8F8F] capitalize">
              {{ formatString(jobDetails?.work_type) }}, {{ jobDetails?.country?.name }} <span class="text-brand-black px-2"> > </span>
              <span class="text-brand-black font-normal text-sm capitalize">{{ jobDetails?.job_category_name }}</span>
            </p>
          </div>

          <div class="flex items-center gap-x-3">
            <button
              class="inline-flex flex-nowrap w-full justify-center items-center rounded-lg px-7 pl-4 py-2 text-sm font-medium bg-brand-black text-white border border-gray-400"
              @click="showAddCandidateToJob = true"
            >
              <img src="@/assets/icons/plusline.svg" class="mr-2" alt="" />
              <span class="inline-block mr-1">Add</span>
              <span>Candidate</span>
            </button>
            <button
              class="inline-flex flex-nowrap w-full justify-center items-center rounded-lg px-7 pl-4 py-2 text-sm font-medium text-brand-black border border-gray-400"
              @click="shareModal = true"
            >
              <img src="@/assets/icons/share.svg" class="w-4 mr-2" alt="" />
              <span class="mr-1">Share</span>
              <span>Job</span>
            </button>
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex w-full justify-center items-center space-x-3 rounded-lg px-7 py-2 text-sm font-medium text-brand-black border border-gray-400"
                >
                  <span>Actions</span>
                  <img src="@/assets/icons/chevron-down.svg" alt="" />
                </MenuButton>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute z-10 origin-top right-0 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none min-w-[185px]"
                >
                  <div class="p-3">
                    <MenuItem>
                      <a
                        href="#"
                        class="p-3 py-2 text-brand-black block text-[14px] hover:bg-light-yellow rounded-lg"
                        :class="{ disabled: jobDetails?.status == 'open' }"
                        @click.prevent="updateApplicationStatus('open')"
                        >Open job</a
                      >
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        class="p-3 py-2 text-brand-black block text-[14px] hover:bg-light-yellow rounded-lg"
                        :class="{ disabled: jobDetails?.status == 'closed' }"
                        @click.prevent="updateApplicationStatus('closed')"
                        >Close job</a
                      >
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>

        <ul
          class="flex flex-wrap justify-between mb-8 text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700"
        >
          <div class="flex items-center">
            <li class="mr-2">
              <a
                href="#"
                @click.prevent="tabNumber = 2"
                :class="{ 'border-b-2 border-brand-black': tabNumber === 2 }"
                class="inline-block p-4 rounded-t-lg hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300 font-semibold text-[16px] text-black/[.5]"
                >Applications
                <span class="bg-brand-black text-white px-[10px] py-[4px] text-[12px] font-bold rounded-[20px] ml-2">{{
                  applications?.length || 0
                }}</span></a
              >
            </li>
            <li class="mr-2">
              <a
                href="#"
                @click.prevent="tabNumber = 1"
                aria-current="page"
                :class="{ 'border-b-2 border-brand-black': tabNumber === 1 }"
                class="inline-block p-4 rounded-t-lg dark:bg-gray-800 font-semibold text-[16px]"
                >Job Details
              </a>
            </li>
          </div>

          <div class="flex items-center mt-4 md:mt-0"></div>
        </ul>
      </div>

      <div>
        <div>
          <div v-if="tabNumber == 1">
            <div class="flex space-x-6">
              <div class="p-6 rounded-2xl bg-white mb-6 w-8/12 border border-light-grey">
                <p class="font-bold text-brand-black text-[14px]">Job description</p>
                <div v-html="jobDetails?.description" class="mt-2 description"></div>
              </div>

              <div class="w-4/12">
                <div class="p-6 rounded-2xl bg-white border border-light-grey mb-5">
                  <div class="mb-6" v-if="jobDetails?.salary_min">
                    <div class="flex items-center">
                      <div class="flex items-center justify-center mr-4 bg-[#FAFAFA] w-10 h-10 rounded-full">
                        <img src="../assets/icons/moneys.svg" class="w-5 h-5" />
                      </div>
                      <div>
                        <small class="text-[14px] text-brand-black/50">Renumeration</small>
                        <h3 class="text-[18px] text-brand-black font-semibold">
                          {{ jobDetails?.salary_currency }}
                          {{ formatNumber(jobDetails?.salary_min) }} - {{ formatNumber(jobDetails?.salary_max) }}
                          <span class="font-semibold">{{ period[jobDetails?.pay_period] }}</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div class="mb-6">
                    <div class="flex items-center">
                      <div class="flex items-center justify-center mr-4 bg-[#FAFAFA] w-10 h-10 rounded-full">
                        <img src="../assets/icons/category1.svg" class="w-5 h-5" />
                      </div>
                      <div>
                        <small class="text-[14px] text-brand-black/50">Category</small>
                        <h3 class="text-[18px] text-brand-black font-semibold capitalize">{{ jobDetails?.job_title_name }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="mb-6">
                    <div class="flex items-center">
                      <div class="flex items-center justify-center mr-4 bg-[#FAFAFA] w-10 h-10 rounded-full">
                        <img src="../assets/icons/briefcase.svg" class="w-5 h-5" />
                      </div>
                      <div>
                        <small class="text-[14px] text-brand-black/50">Employment Type</small>
                        <h3 class="text-[18px] text-brand-black font-semibold capitalize">{{ formatString(jobDetails?.type) }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="mb-6">
                    <div class="flex items-center">
                      <div class="flex items-center justify-center mr-4 bg-[#FAFAFA] w-10 h-10 rounded-full">
                        <img src="../assets/icons/star1.svg" class="w-5 h-5" />
                      </div>
                      <div>
                        <small class="text-[14px] text-brand-black/50">Minimum Experience Level</small>
                        <h3 class="text-[18px] text-brand-black font-semibold capitalize">{{ formatString(jobDetails?.level_of_experience) }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="flex items-center">
                      <div class="flex items-center justify-center mr-4 bg-[#FAFAFA] w-10 h-10 rounded-full">
                        <img src="../assets/icons/location1.svg" class="w-5 h-5" />
                      </div>
                      <div>
                        <small class="text-[14px] text-brand-black/50">Location</small>
                        <h3 class="text-[18px] text-brand-black font-semibold capitalize">
                          {{ jobDetails?.country?.name }} ({{ jobDetails?.work_type }})
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="p-6 rounded-2xl bg-white border border-light-grey mb-5">
                  <div class="mb-4" v-if="jobDetails?.must_have">
                    <h3 class="text-[18px] text-brand-black font-bold mb-6">Must-haves:</h3>
                    <div>
                      <ul class="list-disc pl-10">
                        <li class="mb-2 text-brand-black/50 text-[14px]" v-for="(item, index) in jobDetails?.must_have" :key="index">{{ item }}</li>
                      </ul>
                    </div>
                  </div>

                  <div class="" v-if="jobDetails?.skills">
                    <h3 class="text-[18px] text-brand-black font-bold mb-6">Skills:</h3>
                    <div>
                      <ul class="list-disc pl-10">
                        <li class="mb-2 text-brand-black/50 text-[14px] capitalize" v-for="(item, index) in jobDetails?.skills" :key="index">
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tabNumber == 2" class="mt-8">
            <div class="mb-7" v-if="applications >= 1">
              <!-- Filter and add job -->
              <div class="flex items-center gap-1">
                <div class="relative w-full">
                  <input
                    @keyup.enter="updateFilterParams"
                    v-model="filterKeys.search"
                    type="search"
                    id="default-search"
                    class="block w-full px-4 py-3 pr-10 text-sm text-gray-900 border border-gray-300 rounded-md bg-gray-50"
                    placeholder="Search what you need"
                    required
                  />

                  <button class="absolute right-4 top-3 z-10">
                    <!-- <img src="../assets/icons/search.svg" alt="" /> -->
                  </button>
                </div>
                <div class="flex items-center justify-end px-6">
                  <p class="text-brand-black min-w-[95px] mr-2">{{ tab == 1 ? 'Normal' : 'Table' }} View</p>
                  <div class="inline-flex items-center bg-[#F8F8F8] rounded-3xl p-1">
                    <div class="w-[30px] h-[30px] rounded-full flex items-center justify-center bg-brand-black cursor-pointer" @click="tab = 1">
                      <!-- <img src="../assets/icons/list.svg" alt="" /> -->
                    </div>
                    <div class="w-[30px] h-[30px] rounded-full flex items-center justify-center cursor-pointer" @click="tab = 2">
                      <!-- <img src="../assets/icons/grid.svg" alt="" /> -->
                    </div>
                  </div>
                </div>

                <tam-button
                  class="bg-white hover:bg-white border border-light-grey rounded-xl mr-3"
                  label="Filter"
                  :icon="FilterLine"
                  @click="showFilter = true"
                />
                <tam-button
                  @click="showInviteCandidateDialog = true"
                  class="rounded-xl mr-3 bg-black text-white hover:bg-black"
                  label="Invite Candidate"
                  :icon="Cross"
                />
              </div>
            </div>

            <div class="overflow-x-auto custom-scroll p-4 rounded-md bg-white" v-if="pageLoaded">
              <div v-if="applications < 1" class="flex flex-col justify-center items-center mt-10">
                <p class="text-4xl text-black flex">No Aplication yet</p>
                <tam-button
                  @click="showInviteCandidateDialog = true"
                  class="rounded-xl mr-3 bg-black text-white hover:bg-black mt-5"
                  label="Invite Candidate"
                  :icon="Cross"
                />
              </div>
              <table v-else class="w-full text-sm text-left text-gray-500 p-4">
                <thead class="uppercase bg-[#f5f5f5]">
                  <tr>
                    <th scope="col" class="px-6 py-4 whitespace-nowrap font-semibold capitalize text-left" v-for="item in tableDetails" :key="item">
                      {{ item }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(item, idx) in applications"
                    :key="item.uuid"
                    class="bg-white border-b border-light-grey hover:bg-gray-50/30 cursor-pointer"
                  >
                    <td scope="row" class="font-medium dark:text-white whitespace-nowrap" @click="viewTalentApplication(item?.uuid)">
                      <Popper :hover="true" :offsetSkid="400" :offsetDistance="-100" placement="top" :closeDelay="3">
                        <div class="flex items-center px-6 py-4 w-full">
                          <img :src="item?.candidate?.avatar" alt="image" class="w-[36px] h-[36px] rounded-full mr-3" />
                          <div>
                            <p class="font-semibold text-brand-black text-[14px]">{{ item?.candidate?.name }}</p>
                            <small class="text-[12px] lowercase font-normal">{{ resumeString(item?.resume_url) }}</small>
                          </div>
                        </div>
                        <template #content>
                          <div class="w-[500px] p-6 rounded-md shadow-md bg-[#f0f2f5] border-2 border-white">
                            <div class="flex items-center justify-between gap-x-4 mb-1">
                              <div class="p-2 rounded-md bg-green text-white font-bold" :class="randomBg()">
                                {{ nameInitials(item?.candidate?.name) }}
                              </div>
                              <div class="flex-1">
                                <p class="font-semibold text-brand-black text-[14px] mb-2">{{ item?.candidate?.name }}</p>
                              </div>
                              <div></div>
                            </div>

                            <div class="pl-12 mb-4">
                              <div class="flex gap-x-2 items-center mb-2">
                                <img src="@/assets/icons/briefcase.svg" alt="" />
                                <p class="text-[12px]">{{ Number(item?.candidate?.years_of_experience) }} Years</p>
                              </div>
                              <p class="mb-2 text-[12px] text-lime-600">#Careerpage</p>

                              <div class="flex justify-between items-center gap-x-4">
                                <div class="flex items-center gap-x-3">
                                  <img src="@/assets/icons/upload2.svg" alt="" />
                                  <p class="text-sm lowercase">{{ moment(item?.created_at).startOf('hour').fromNow() }}</p>
                                </div>
                                <span :class="['px-3 py-1 text-[12px] rounded-md ', badgeColor(item.status)]">{{ item.status }}</span>
                              </div>
                            </div>

                            <div class="pt-2 border-t border-gray-200">
                              <div class="flex items-center flex-nowrap gap-x-6">
                                <button
                                  v-tooltip.top="'View application'"
                                  class="w-[20px] h-[20px] cursor-pointer mr-2"
                                  @click="viewTalentApplication(item?.uuid)"
                                >
                                  <img src="@/assets/icons/eyeline.svg" alt="" />
                                </button>

                                <button v-tooltip.top="'Share'" class="w-[20px] h-[20px] cursor-pointer mr-2" @click="shareProfile(item)">
                                  <img src="@/assets/images/share.png" alt="" />
                                </button>

                                <button v-tooltip.top="'Email candidate'" class="w-[20px] h-[20px] cursor-pointer mr-2" @click="emailTalent(item)">
                                  <img src="@/assets/images/invitation.png" alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </template>
                      </Popper>
                    </td>

                    <td class="px-6 py-4 text-sm">
                      <div class="flex items-center gap-x-3 mb-2">
                        <img src="@/assets/icons/messageline.svg" alt="" />
                        <p class="lowercase font-semibold text-[#1890ff]">{{ item?.candidate?.email }}</p>
                      </div>
                      <div class="flex items-center gap-x-3">
                        <img src="@/assets/icons/phoneline.svg" class="w-4" alt="" />
                        <p class="font-semibold text-[#1890ff]">080-------------</p>
                      </div>
                    </td>

                    <td
                      class="px-2 py-4"
                      @click="
                        selectedApplication = item;
                        selectedApplicationIdx = idx;
                      "
                    >
                      <span :class="['px-2 py-1 text-[12px] rounded-md inline-flex flex-nowrap', badgeColor(item.status)]"
                        >{{ item.status }} <span class="inline-block ml-1">&#x2BC6;</span></span
                      >
                    </td>

                    <td class="px-6 py-4" @click="viewTalentApplication(item?.uuid)">
                      <span class="lowercase">
                        {{ moment(item?.created_at).startOf('hour').fromNow() }}
                      </span>
                    </td>

                    <td class="px-6 py-4">
                      <!-- <div class="flex items-center flex-nowrap">
                        <button
                          v-tooltip.top="'View application'"
                          class="w-[20px] h-[20px] cursor-pointer mr-2"
                          @click="viewTalentApplication(item?.uuid)"
                        >
                          <EyeIcon />
                        </button>

                        <button v-tooltip.top="'Share'" class="w-[20px] h-[20px] cursor-pointer mr-2" @click="shareProfile(item)">
                          <img src="../../assets/icons/share.png" alt="" />
                        </button>

                        <button v-tooltip.top="'Email candidate'" class="w-[20px] h-[20px] cursor-pointer mr-2" @click="emailTalent(item)">
                          <img src="../../assets/icons/invitation.png" alt="" />
                        </button>
                      </div> -->
                      <Menu as="div" class="relative inline-block text-left z-40">
                        <div>
                          <MenuButton class="inline-flex w-full justify-center rounded-md px-4 py-2 text-sm font-medium text-gray-700 relative z-10">
                            <div class="w-10 h-10 hover:bg-gray-100 rounded-full border flex justify-center items-center">
                              <More />
                            </div>
                          </MenuButton>
                        </div>

                        <transition
                          enter-active-class="transition ease-out duration-100"
                          enter-from-class="transform opacity-0 scale-95"
                          enter-to-class="transform opacity-100 scale-100"
                          leave-active-class="transition ease-in duration-75"
                          leave-from-class="transform opacity-100 scale-100"
                          leave-to-class="transform opacity-0 scale-95"
                        >
                          <MenuItems
                            class="absolute z-50 origin-top right-0 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none min-w-[185px]"
                          >
                            <div class="p-1 py-2">
                              <MenuItem>
                                <a
                                  href="#"
                                  @click.prevent
                                  @click="viewTalentApplication(item?.uuid)"
                                  class="inline-flex px-4 pl-0 py-2 text-brand-black"
                                >
                                  <img src="@/assets/icons/eyeline.svg" class="pl-2 mr-2" alt="" />
                                  <span>View Application</span>
                                </a>
                              </MenuItem>
                              <MenuItem>
                                <a href="#" @click.prevent="shareProfile(item)" class="inline-flex items-center pl-2 px-4 py-2 text-brand-black">
                                  <img src="@/assets/images/share.png" class="mr-2 w-5" alt="" />
                                  <span> Share Profile</span>
                                </a>
                              </MenuItem>
                              <MenuItem>
                                <a href="#" @click.prevent="emailTalent(item)" class="inline-flex items-center pl-2 px-4 py-2 text-brand-black">
                                  <img src="@/assets/images/invitation.png" class="mr-2 w-5" alt="" />
                                  <span> Email Candidate</span>
                                </a>
                              </MenuItem>
                            </div>
                          </MenuItems>
                        </transition>
                      </Menu>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <paginate
      v-if="tab == 2"
      :from="paginateContent?.meta?.from"
      :to="paginateContent?.meta?.to"
      :total="paginateContent?.meta?.total"
      :currentPage="paginateContent?.meta?.current_page"
      :nextPage="paginateContent?.links?.next"
      :prevPage="paginateContent?.links?.prev"
      :links="paginateContent?.meta?.links"
      :navigations="paginateContent?.links"
      :perPage="paginateContent?.meta?.per_page"
      @move="doPaginate"
    />

    <!--  <invite-to-job v-if="showInvite" @closeInvite="closeInviteModal" /> -->
  </div>

  <share-profile-dialog
    :open="showProfileShareDialog"
    :app-details="profileToShare"
    @on-close="
      showProfileShareDialog = false;
      profileToShare = null;
    "
  />

  <send-mail-dialog
    :open="showSendMailDialog"
    :talent-details="profileToShare"
    @on-close="
      showSendMailDialog = false;
      profileToShare = null;
    "
  />

  <application-details-dialog v-if="selectedAppId" :app-id="selectedAppId" :job-id="route.params.id" @close="selectedAppId = ''" />

  <update-status-dialog
    :is-active="selectedApplication ? true : false"
    :status="selectedApplication?.status"
    :stages="stages"
    :application="selectedApplication"
    @close="selectedApplication = null"
    @confirm="updateCurrentList"
  />

  <share-job-modal v-if="shareModal" :job-details="jobDetails" :user="user" @close="shareModal = false" />

  <add-candidate-to-job-dialog :is-active="showAddCandidateToJob" :jobId="jobDetails?.uuid" @close="showAddCandidateToJob = false" />
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import { useRouter, useRoute } from 'vue-router';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import Empty from '@/components/Empty.vue';
import TamButton from '@/components/TamButton.vue';
import TamModal from '@/components/TamModal.vue';
import Loader from '@/components/LoadingOverlay.vue';
import { Paginate } from '@/components/index.js';
import { errorMessage, saveResumeUrl, alert, formatNumber, formatString, badgeColor, nameInitials, randomBg } from '@/utils/helper';
import Back from '@/components/BackButton.vue';
import { useToast } from 'vue-toastification';
import ApplicationDetailsDialog from '@/components/applications/ApplicationDetailsDialog.vue';
import UpdateStatusDialog from '@/components/applications/UpdateStatusDialog.vue';
import ShareProfileDialog from '@/components/applications/ShareProfile.vue';
import SendMailDialog from '@/components/talent/SendTalentsMail.vue';
import ShareJobModal from '@/components/ShareJobModal.vue';
import AddCandidateToJobDialog from '@/components/job/AddCandidateToJob.vue';

const props = defineProps({
  type: { type: String, default: 'all' },
  job: { type: Object },
});

const tableDetails = ref(['Candidate', 'Contact', 'Status', 'Date Applied', 'Action']);

const store = useStore();
const router = useRouter();
const route = useRoute();
const toast = useToast();

const pageLoaded = ref(false);
const shareModal = ref(false);
const showAddCandidateToJob = ref(false);
const tabNumber = ref(2);
const jobDetails = ref();
const selectedAppId = ref('');
const profileToShare = ref(null);
const selectedApplication = ref(null);
const selectedApplicationIdx = ref(-1);

const period = ref({
  per_month: 'monthly',
  per_year: 'yearly',
  per_day: 'daily',
  per_week: 'weekly',
});
const filterKeys = ref({
  search: '',
});
const tab = ref(1);
const checkbox = ref(false);
const loading = ref(false);
const showFilter = ref(false);
const applications = ref([]);
const showProfileShareDialog = ref(false);
const showSendMailDialog = ref(false);
const stages = ref([]);

const paginateContent = computed(() => {
  return store.getters['global/getJobApplicationsPayload'];
});

const doPaginate = async ({ params }) => {
  getAllApplications(params);
};

const updateFilterParams = () => {
  const params = Object.entries(filterKeys.value).reduce((a, [k, v]) => (v == '' ? a : ((a[k] = v), a)), {});
  if (!Object.keys(params).length) return false;
  getAllApplications(params);
};

const resumeString = (url) => {
  const list = url.split('/');
  if (!list.length) return 'Resume pdf not found';

  const pdf = list.filter((item) => item.includes('.pdf'))[0];
  if (!pdf) return 'Resume pdf not found';

  return pdf.split('?')[0];
};

const updateCurrentList = (status) => {
  if (selectedApplicationIdx.value > -1) {
    applications.value[selectedApplicationIdx.value].status = status;
  }
  selectedApplication.value = null;
  selectedApplicationIdx.value = -1;
};

const shareProfile = (item) => {
  showProfileShareDialog.value = true;
  profileToShare.value = item?.candidate;
};

const emailTalent = (item) => {
  showSendMailDialog.value = true;
  profileToShare.value = item?.candidate;
};

const getAllApplications = async (uuid) => {
  try {
    loading.value = true;
    // const uuid = route.params.id.split(':').join('');
    applications.value = await store.dispatch('global/getSingleJobApplications', uuid);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
};

const updateApplicationStatus = async (status) => {
  loading.value = true;
  try {
    const res = await store.dispatch('global/updateApplicationStatus', { id: route.params.id, status });
    toast.success(res.message, {
      timeout: 3000,
      hideProgressBar: true,
    });
    await getJobDetails();
  } catch (error) {
    alert(errorMessage(error), 'error', 5000);
  } finally {
    loading.value = false;
  }
};

const user = computed(() => {
  return store.getters['auth/userDetails'];
});

const viewTalentApplication = (uuid) => {
  selectedAppId.value = uuid;
};

const getJobDetails = async () => {
  try {
    const uuid = route.params.id;
    jobDetails.value = await store.dispatch('global/getSingleJob', uuid);

    await getAllApplications(uuid);
  } catch (error) {
  } finally {
    pageLoaded.value = true;
  }
};

const getAppStages = async () => {
  loading.value = true;
  try {
    const result = await store.dispatch('global/getApplicationStatuses');
    stages.value = result;
  } catch (error) {
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await Promise.all([getJobDetails(), getAppStages()]);
});
</script>

<style lang="scss" scoped>
.column-width {
  min-width: 320px;
  width: 320px;
}

/* Unfortunately @apply cannot be setup in codesandbox,
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.ghost-card {
  @apply border opacity-50 border-blue-500 bg-gray-200;
}

.drag-container::v-deep {
  .drag-inner-list {
    height: 480px !important;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0.6vw;
      background: #ccc;
    }

    &::-webkit-scrollbar-thumb {
      background: #ff2449;
      background: #ff2449;
      border-radius: 20px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: -webkit-linear-gradient(transparent, #00c6ff);
      background: linear-gradient(transparent, #00c6ff);
    }
  }
}
</style>
